import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveServicioClienteComponent } from '../../shared/components/SaveServicioClienteComponent';

export interface NewServicioClientePageProps {}

const NewServicioClientePage: React.FC<NewServicioClientePageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_olt);

  return <SaveServicioClienteComponent title="Crear/Asociar Servicio" />;
};

export default NewServicioClientePage;
